import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core'
import { FDLMService } from '../../services/FDLM.Service';//SE IMPORTA EL SERVICIO
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';//PARA TRABAJAR CON FORMULARIOS //Validators: PARA AGREGAR VALIDACIONES SOBRE LOS CAMPOS
import { TipoDocumento, ValidaCargaRQ } from '../../Interfaces';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Component({
  selector: "importador",
  templateUrl: "./importador.component.html"
})
export class importador implements OnInit {
  [x: string]: any;

  //PARAMETROS DE ENTRADA AL COMPONENTE
  @Input() varNumSolicitud: string;
  //EVENTO DE SALIDA
  @Output() cancelarImportarButton: EventEmitter<any>;
  @Output() finalizaImportacionEvent: EventEmitter<any>;

  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;

  //VARIABLES PROPIAS DEL COMPONENTE
  public isLoaded: boolean = false;
  public lstTipodoc: Observable<TipoDocumento[]>;
  public tmpArchivo: any;
  public varIdAccionCarpertaEstCredito: number;
  public NoClick: boolean = true;

  
  archivoSeparador: UntypedFormGroup;

  //CONSTRUCTOR
  constructor(private FDLMService: FDLMService, public snackbar: MatSnackBar) {
    //INSTANCIAR EL EVENTO DEL BOTON CANCELAR
    this.cancelarImportarButton = new EventEmitter();
    this.finalizaImportacionEvent = new EventEmitter();
   
    this.archivoSeparador = new UntypedFormGroup({
      //DENTRO DE CADA FORMGROUP HAY UN OBJETO QUE SE REFERENCIA COLOCANDO CADA PROPIEDAD : VALOR CON CADA UNO DE LOS CAMPOS
      'tmpIdTipoDocumento': new UntypedFormControl("0",[Validators.required,this.ValidaTipoDocumento]),
      'tmpArchivo': new UntypedFormControl("",[Validators.required])
    });
  }

  //LO EJECUTA CUANDO INICIA LA PAGINA
  public ngOnInit() {
    //SE ENVIA A CARGAR EL TIPO_DOCUMENTO
    this.CargarTipoDocumento();
    this.NoClick = true;
  }

  public CargarTipoDocumento() {
    this.lstTipodoc = this.FDLMService.GetTblInfoTipoDocumentoXTRDParams(this.FDLMService.usuarioData.idEmpSede);
    this.isLoaded = true;
  }
  //EVENTO BOTON CANCELAR IMPORTACION
  public CancelarImportacion() {
    this.cancelarImportarButton.emit();
  }

  public SetConfiguraAccionCarpertaEstCredito(parIdAccionCarpertaEstCredito) {
    this.varIdAccionCarpertaEstCredito = parIdAccionCarpertaEstCredito;
  }

  //EVENTO SUBMIT DEL FORMULARIO
  public ImportarArchivo(event: any) {
    //console.log('Cargando doc');
    //this.NoClick = !this.NoClick;
    this.NoClick = false;
    try {
      //VALIDA QUE LE FORMULARIO QUEDE VALIDO PARA IMPORTAR
      if (this.archivoSeparador.valid == true) {

        //OBTIENE EL TIPO_DOCUMENTO SELECCIONADO
        var varDdlTipoDoc = (<HTMLSelectElement>document.getElementById("tipoDocumento"));
        var varIdTipoDocumento = varDdlTipoDoc.options[varDdlTipoDoc.selectedIndex].value;

        this.FDLMService.ValidaCargaDoc(this.varNumSolicitud, Number(varIdTipoDocumento)).subscribe(
          data => {
            if (data.idEstado === 1) {

              const fileup = this.fileUpload.nativeElement;
              var archivo = fileup.files[0];

              //SI LA ACCION RELACIONADA AL ESTADO_CREDITO ES BLOQUEAR MODIFICACION
              if (this.varIdAccionCarpertaEstCredito == 3) {
                //ACA SE DEBE VALIDAR SI PARA LA SOLICITUD Y TIPO DE DOCUMENTO YA EXISTE OTRO DOC EN CASO QUE SI NO DEBE PERMITIR MODIFICAR
              }

              //OBTIENE EL ARCHIVO SELECCIONADO
              var varFileArchivo = (<HTMLInputElement>document.getElementById("fuArchivo")).files[0];
              const formData = new FormData();
              formData.append("IdTipoDocumento", varIdTipoDocumento);
              formData.append("NumSolicitud", this.varNumSolicitud);
              formData.append("Soporte", archivo);

              this.snackbar.open('Cargando Documento ...', '', { duration: 3000 });

              //formData.append('file', archivo, archivo.name);
              this.FDLMService.GuardaArch(formData).subscribe(
                (res) => {
                  if (res.idEstado == 1) {
                    this.snackbar.open('Documento Guardado Satisfactoriamente', '', { duration: 3000 });
                    this.finalizaImportacionEvent.emit();
                  }
                  else {                    
                    this.FDLMService.GuardaError("ImportarArchivo", JSON.stringify(res), "", "").subscribe();
                    Swal.fire({ text: 'Error cargando Guardando documento: ' + JSON.stringify(res) + ' Det:' + res.mensaje + ' Det:' + res.data , icon: 'warning', confirmButtonText: "Aceptar" });
                  }
                  event.target.disabled = false;
                  this.NoClick = !this.NoClick;
                },
                (err) => {
                  console.log(err);
                  this.FDLMService.GuardaError("ImportarArchivo Error", JSON.stringify(err), this.varNumSolicitud, "").subscribe();
                  Swal.fire({ text: 'Error cargando Guardando documento' + err, icon: 'warning', confirmButtonText: "Aceptar" });
                  event.target.disabled = false;
                  this.NoClick = !this.NoClick;
                });
            }
            else {
              Swal.fire({ text: data.mensaje, icon: 'warning', confirmButtonText: "Aceptar" });
              event.target.disabled = false;              
              this.NoClick = !this.NoClick;
            }
          }
        );
      }
    }
    catch (error) {
      Swal.fire({ text: error.message, icon: 'warning', confirmButtonText: "Aceptar" });
      event.target.disabled = false;
      this.NoClick = !this.NoClick;
    }
  }

  //VALIDACION TIPO DOCUMENTO
  public ValidaTipoDocumento(control: UntypedFormControl) {
    if (<string>control.value.toString() == "0") {
      return { TipoDocumentoValido: false };
    }

    return null;
  }

}
